import React from 'react'
import { useTranslation } from 'react-i18next'

import { GridContainer } from '../../components/DashboardTiles/DashboardTiles.styles'
import HeaderText from '../../styles/HeaderText'
import { ModalContentContainer } from './PriceList.styles'

// Verlinde only.
const PriceList = () => {
  const { t } = useTranslation()

  return (
    <ModalContentContainer>
      <GridContainer>
        <HeaderText style={{ margin: '0 0 1rem 0' }}>
          {t('price_list')}
        </HeaderText>
        {t('refer_to_sales')}
      </GridContainer>
    </ModalContentContainer>
  )
}

export default PriceList
